import React, { useEffect, useRef } from 'react';

/**
 * Google AdSense ad unit component.
 * Replace ADSENSE_PUB_ID with your actual ca-pub-XXXXXXXXXXXXXXXX ID.
 * 
 * Variants:
 *  - "banner"    : Horizontal banner between sections (728x90 desktop)
 *  - "in-article": Fluid ad within blog article content
 *  - "sidebar"   : Rectangle ad for sidebar / tips area (300x250)
 */

const ADSENSE_PUB_ID = 'ca-pub-7258293854170874';

const AD_CONFIGS = {
  banner: {
    style: { display: 'block', textAlign: 'center', margin: '12px auto', maxWidth: '728px' },
    format: 'auto',
    slot: '2509226417',
  },
  'in-article': {
    style: { display: 'block', textAlign: 'center', margin: '2em 0' },
    format: 'fluid',
    layout: 'in-article',
    slot: '1196144740',
  },
  sidebar: {
    style: { display: 'block', margin: '16px auto' },
    format: 'auto',
    slot: '8468130104',
  },
};

const AdUnit = ({ variant = 'banner', className = '' }) => {
  const adRef = useRef(null);
  const config = AD_CONFIGS[variant] || AD_CONFIGS.banner;
  const isPlaceholder = ADSENSE_PUB_ID === 'ca-pub-XXXXXXXXXXXXXXXX';

  useEffect(() => {
    if (isPlaceholder) return;
    try {
      if (window.adsbygoogle && adRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      // AdSense not loaded yet
    }
  }, [isPlaceholder]);

  // Show placeholder box when AdSense ID isn't configured yet
  if (isPlaceholder) {
    return null;
  }

  return (
    <div className={className} style={{...config.style, overflow: 'hidden', maxHeight: 0, transition: 'max-height 0.3s'}} ref={adRef} data-testid={`ad-${variant}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_PUB_ID}
        data-ad-slot={config.slot}
        data-ad-format={config.format}
        {...(config.layout ? { 'data-ad-layout': config.layout } : {})}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdUnit;
export { ADSENSE_PUB_ID };
